import { useNavigate } from "react-router-dom";
import urls from "../../config/urls.json";
import { useSession } from "../../hooks/useSession";
import { useStates } from "../../hooks/useStates";
import { useEffect, useRef, useState } from "react";
import { ApiService as api } from "../../services/ApiService";
import { getYMD } from "../../services/formatters";
import { useAppointmentResponse } from "../../hooks/useAppointmentResponse";
import { useDynatrace } from "../../hooks/useDynatrace";

export const useEditAppointmentPage = () => {
    const navigate = useNavigate();
    const { read, update, batchUpdate, reloadAppOnBack } = useSession();
    const { states, setCurrentState, isFilialiSlideBusy, isCfPageReady } = useStates();
    const { handleAppointmentSubmission, handleAppointmentC5Submission, fetchErrorMessage, fetchError, setFetchError, isCreaAppuntamentoBusy, isCreaAppuntamentoError } = useAppointmentResponse();

    const [knownUser, setKnownUser] = useState(true);
    const [currentMapToShow, setCurrentMapToShow] = useState("");
    const [vuoleRicontatto, _setVuoleRicontatto] = useState(true);
    const [filialiFetchError, setFilialiFetchError] = useState(false);
    const [fetchFilialiErrorMessage, setFilialiFetchErrorMessage] = useState("");

    let subSlider = useRef();
    let daySlider = useRef();

    useEffect(() => {
        reloadAppOnBack();
    }, []);

    const {} = useDynatrace();

    useEffect(() => {
        // se non ce appuntamentoGiaFissato torna indietro subito ed esci da qui
        const appointmentData = read("appuntamentoGiaFissato");
        if (!appointmentData || !read("filialeScelta")) navigate(-1);
    }, []);

    const next = async () => {
        if (read("prodotto") == 1) {
            handleAppointmentSubmission();
        } else {
            handleAppointmentC5Submission();
        }
    };

    const onFilialiSlideChange = (filialeIdx) => {
        setCurrentState(states.LOAD_FILIALI_SLIDES_START);
        // update("filialeScelta", read("filiali")[filialeIdx]);
        // update("disponibilita", read("filiali")[filialeIdx].days);
        // update("dataScelta", read("filiali")[filialeIdx].days[0]);
        batchUpdate({
            filialeScelta: read("filiali")[filialeIdx],
            disponibilita: read("filiali")[filialeIdx].days,
            dataScelta: read("filiali")[filialeIdx].days[0],
        });
        // force change on giorniSlider to automate call to Disponibilita
        onGiorniSlideChange(0);
        daySlider.current.go(0);
    };

    const onGiorniSlideChange = async (giornoIdx) => {
        setCurrentState(states.LOAD_FILIALI_SLIDES_START);
        update("dataScelta", read("disponibilita")[giornoIdx]);

        // call new Disponibilita
        let disponibilitaResult = {};
        try {
            disponibilitaResult = await api.Disponibilita({
                CodFiliale: read("filialeScelta").codFiliale,
                Giorno: getYMD(read("dataScelta").data),
                TipoFiliali: 0,
            });
        } catch (error) {
            setFilialiFetchErrorMessage("C'è stato un errore nel caricamento delle disponibilità delle filiali. <br />Per favore riprova.");
            setFilialiFetchError(true);
            return;
        }

        update("orari", disponibilitaResult.orariDisponibili);

        let favouriteHour = disponibilitaResult.orariDisponibili.filter((_) => _.disponibile == true)[0];
        let eligibleOrarioScelto = [];
        if (read("orarioScelto")) {
            eligibleOrarioScelto = disponibilitaResult.orariDisponibili.filter((_) => _.disponibile == true && _.hour == read("orarioScelto").hour && _.minute == read("orarioScelto").minute);
        }
        if (eligibleOrarioScelto.length > 0) {
            favouriteHour = eligibleOrarioScelto[0];
        }

        update("orarioScelto", favouriteHour);
        setCurrentState(states.LOAD_FILIALI_SLIDES_END);
    };

    const showMap = (id, coords) => {
        if (currentMapToShow.length) {
            setCurrentMapToShow("");
            destroyMap(id);
        } else {
            setCurrentMapToShow(id);
            renderMap(id, coords);
        }
    };
    const renderMap = (id, coords) => {
        const appleMapManager = window.AppleMapManager();
        appleMapManager.renderMap(id, {
            latitude: coords.lat,
            longitude: coords.lng,
        });
    };
    const destroyMap = (id) => {
        setTimeout(() => {
            const mapNode = document.getElementById(id);
            mapNode.innerHTML = "";
        }, 500);
    };

    const getAppuntamentoData = (key) => {
        const appto = read("appuntamentoGiaFissato");
        return appto[key];
    };

    const switchToEditFormData = () => {
        if (read("prodotto") == 3) {
            navigate(urls.datiPersonaliNonRiconosciutoC5.path, { state: { lockFields: true } });
        } else {
            batchUpdate({
                email: "",
                cellulare: "",
            });
            setKnownUser(false);
        }
    };

    return {
        next,
        read,
        vuoleRicontatto,
        isCreaAppuntamentoError,
        isCreaAppuntamentoBusy,
        fetchErrorMessage,
        fetchError,
        setFetchError,
        getAppuntamentoData,
        switchToEditFormData,
        knownUser,
    };
};
